export const get = (obj: any, path: string, defValue?: any) => {
    if (!path) {
        return undefined;
    }

    const pathArray = Array.isArray(path) ? path : (path.match(/(?<temp1>[^[.\]])+/gu) as any[]);
    const result = pathArray.reduce((prevObj: any, key: string) => prevObj?.[key], obj);
    return result === undefined ? defValue : result;
};
